import { type Location, useLocation } from "react-router";

/** Router state that opens an issue as a modal over the page it was opened from. */
export interface IssueModalState {
  backgroundLocation: Location;
}

/** The page an issue modal sits over, when the current location is one. */
export function backgroundLocationOf(state: unknown): Location | undefined {
  if (!state || typeof state !== "object" || !("backgroundLocation" in state)) return undefined;
  return (state as IssueModalState).backgroundLocation;
}

/**
 * Router state for a link to another issue: inside an issue modal it keeps the
 * same background, so the next issue opens in the modal too.
 */
export function useIssueLinkState(): IssueModalState | undefined {
  const background = backgroundLocationOf(useLocation().state);
  return background ? { backgroundLocation: background } : undefined;
}
